import { combineReducers } from "redux";

import Layout from "./layout/reducer";

import Login from "./auth/login/reducer";
import ForgetPassword from "./auth/forgetpwd/reducer";
import ResetPassword from "./auth/resetPwd/reducer";
import RegisterReducer from "./auth/register/reducer";
/////////
import CampaignReducer from "./contents/campaign/reducer";
import ScreenReducer from "./contents/screen/reducer";
import SavedCampaigns from "./contents/saved_campaign/reducer";
import AdminReducer from "./contents/admin/reducer";
import ReportReducer from "./contents/report/reducer";

const rootReducer = combineReducers({
    Layout,
    Login,
    ForgetPassword,
    ResetPassword,
    RegisterReducer,

    //
    CampaignReducer,
    ScreenReducer,
    SavedCampaigns,
    AdminReducer,
    ReportReducer
});

export default rootReducer;
